import { render, staticRenderFns } from "./machine-item.vue?vue&type=template&id=2f9bb0c5&"
import script from "./machine-item.vue?vue&type=script&lang=js&"
export * from "./machine-item.vue?vue&type=script&lang=js&"
import style0 from "./machine-item.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports